import { Component, OnDestroy, OnInit, ViewChild, ViewEncapsulation } from '@angular/core';
import { Subject, takeUntil } from 'rxjs';
import { ActivatedRoute } from '@angular/router';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { environment } from '../../environments/environment';
import { OktaService } from '../shared/services/okta.service';

/** Tech Library PDF Generator  */
@Component({
    selector: 'pd-tech-library',
    templateUrl: './tech-library.component.html',
    styleUrls: ['./tech-library.component.scss'],
    encapsulation: ViewEncapsulation.None
})
export class TechLibraryComponent implements OnInit, OnDestroy {
    private unsubscribe = new Subject<void>();
    fileName = "Tech Library.pdf";
    pdfLoadError = false;
    pdfLoading = true;
    catalogLoadError = false;
    catalogLoading = true;
    id: string = '';
    category: string = '';
    autoDownload = false;

    @ViewChild('pdfViewerOnDemand') pdfViewerOnDemand: any;

    get loading(): boolean {
        return this.pdfLoading;
    }

    get loadError(): boolean {
        return this.pdfLoadError;
    }

    constructor(
        private http: HttpClient,
        private route: ActivatedRoute,
        private oktaService: OktaService
    ) { }

    ngOnInit() {
        this.route.queryParams.pipe(takeUntil(this.unsubscribe)).subscribe(params => {
            if (params['name']) {
                this.fileName = "Tech Library " + params['name'] + ".pdf";
                this.loadTechLibrary(params['name']);
            } else {
                this.pdfLoadError = true;
                this.pdfLoading = false;
            }

        });
    }

    loadTechLibrary( name:string ): void {
        let headers = new HttpHeaders();
        headers = headers.append('Content-Type', 'application/json');
        headers = headers.append('Authorization', `Bearer ${this.oktaService.accessToken}`);
        const options = { headers: headers };

        this.http.post<any>(environment.azure.url + '/admin.techlibrary.generate', {
            name: name
        }, options)
            .subscribe({
                next: (data) => {
                    this.pdfLoading = false;
                    this.pdfLoadError = false;

                    this.pdfViewerOnDemand.pdfSrc = this.convertDataURIToBinary(data.documentBytes);
                    this.pdfViewerOnDemand.refresh();
                },
                error: (msg) => {
                    this.pdfLoading = false;
                    this.pdfLoadError = true;
                    console.log(msg);
                }
            });
    }

    convertDataURIToBinary(dataURI: string) {
        var raw = window.atob(dataURI);
        var rawLength = raw.length;
        var array = new Uint8Array(new ArrayBuffer(rawLength));

        for (var i = 0; i < rawLength; i++) {
            array[i] = raw.charCodeAt(i);
        }
        return array;
    }

    ngOnDestroy() {
        this.unsubscribe.next();
        this.unsubscribe.complete();
    }
}
